// AUTO-GENERATED BY PREFETCH-AGGREGATOR-PLUGIN
// DO NOT EDIT MANUALLY
import { useExecutePrefetch as useExecutePrefetch0 } from '../pages/homepage/prefetch';
export function usePrefetchDuringAppExe() {
  useExecutePrefetch0();
}